import { useState } from "react";
import Input from "./Input";
import Select from "./select/Select";

const UrlInput = ({
  value,
  onChange = () => { },
  placeholder,
  label,
  labelClasses,
  required,
  errorType,
  errorText,
  name,
}) => {
  const [protocol, setProtocol] = useState("https://");

  const handleChange = (e) => {
    const inputVal = e?.target?.value ?? ""; // fallback to empty string
    const fullUrl = inputVal ? `${protocol}${inputVal}` : "";

    if (e?.target) {
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: fullUrl,
          name: name || e.target.name,
        },
      };
      onChange(syntheticEvent);
    } else {
      onChange({ target: { name: name || undefined, value: fullUrl } });
    }
  };

  const handleProtocolChange = (val) => {
    const newProtocol = val;
    setProtocol(newProtocol);

    const strippedUrl = (value || "").replace(/^https?:\/\//, "");
    onChange({ target: { name, value: `${newProtocol}${strippedUrl}` } });
  };

  return (
    <div className="relative w-full">
      {label && (
        <div
          className={
            "text-xs font-medium text-text-disabled mb-1 font-CanelaDeck " +
            labelClasses
          }
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <div className="flex rounded-md w-full">
        {/* <div className="flex-shrink-0 -mr-px">
          <Select
            dropdownData={[
              { name: "http://", value: "http://" },
              { name: "https://", value: "https://" },
            ]}
            selectedValue={protocol}
            onChange={handleProtocolChange}
            dropdownButtonClass={"!rounded-r-none !rounded-l-md bg-slate-100 !h-10"}
            dropdownClass={"!w-28"}
          />
        </div> */}

        <Input
          type="text"
          inputName={name}
          inputPlaceholder={placeholder || "mysite.com"}
          value={(value || "").replace(/^https?:\/\//, "")}
          onChange={handleChange}
          inputClasses="flex-grow"
        />
      </div>
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-600 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default UrlInput;
